import React, { useState, useEffect } from 'react';
import { Tabs, Button, message } from 'antd';
import './styles.css'
import { connect } from 'react-redux';
import { Notification } from 'services';
import { getOrgDetails, uploadDocument, postKycDetails, fetchPinCodeDetails } from 'actions/kyc';
import PageDataLoader from 'components/pageDataLoader';
import { useHistory } from 'react-router-dom';
import { Prompt } from 'react-router'
import SubmitSuccess from './modals/submitSuccess'
import ImgViewModal from './modals/imgView';
import EditCommentModal from './modals/editComment';
import { documentDetailsPvt, documentDetailsProp, documentDetailsPartner, documentDetailsNtRegistered, } from './documentForm';
import { contactInfo } from './contactForm';
import { businessInfo } from './businessInfoForm';
import { bankDetails } from './bankDetailsForm';
import { gstExemption, GST_EXEMPTION_EDUCATIONAL } from './gstExemptionForm';
import { agreement } from './agreement';
import ConfirmSubmitModal from './modals/confirmSubmitModal';
import { postMobileNumberForRegistration, postVerifyOtpForRegistration, setVerfiyOtpModal, verifiedOtpForRegistrationAction } from 'actions/login';
import { ArrowLeftOutlined } from '@ant-design/icons';

const ifsc = require('ifsc');
const { TabPane } = Tabs;
let params = {};
// gst_exempted is a tri-state on the form: true / false / "not answered yet".
// Normalise whatever shape the column comes back as (bool, 0/1, "true"/"false")
// without collapsing a genuine `false` into "unanswered" - the Next button on
// the GST tab has to be able to tell those two apart.
function normalizeTriStateBool(val) {
    if (val === true || val === 1 || val === "true" || val === "1") return true;
    if (val === false || val === 0 || val === "false" || val === "0") return false;
    return undefined;
}

export function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

const actionButtons = (selectedTab, changeFormPage, kycDetails, handleSaveClick, disableSave, disableSave2, disableSave3, submitLoader, verifiedOtpforRegistration) => {
    return (
        <div className={selectedTab !== 'contactInfo' ? "r-jsb" : "r-c-c"} style={{ width: 300 }} >
            {selectedTab !== '1' ? <Button shape="round" style={{ width: 140 }} onClick={() => changeFormPage((parseInt(selectedTab) - 1).toString())}>
                Previous
            </Button> : null}
            <Button type="primary" shape="round" style={{ width: 150 }}
                disabled={
                    (selectedTab === '1' && (kycDetails.contactName === "" || kycDetails.contactPhone === "" || kycDetails.contactEmail === "" || !kycDetails.emailValid || verifiedOtpforRegistration === false)) ||
                    (selectedTab === '2' && disableSave) ||
                    (selectedTab === '3' && disableSave3) ||
                    (selectedTab === '4' && (kycDetails.beneficiaryName === "" || kycDetails.ifscValid !== true ||
                        kycDetails.accNoMatch !== true || !kycDetails.cancelled_cheque || kycDetails.cancelled_cheque_status === "rejected")) ||
                    (selectedTab === '5' && disableSave2) ||
                    (selectedTab === '6' && (!kycDetails.agreementAccepted || kycDetails.kycStatus === "Submitted" || kycDetails.kycStatus === "Approved"))

                }
                loading={selectedTab === '6' && submitLoader}
                onClick={() => handleSaveClick()}>
                {selectedTab === '6' ? "Submit" : "Next"}
            </Button>
        </div>
    )
}


function KycForm({
    getOrgDetails, fetchPinCodeDetails,
    uploadDocument, postKycDetails, organisationDetails,
    verifiedOtpforRegistration, setVerfiyOtpModal,
    postMobileNumberForRegistration, verfiyOtpModal,
    otpKey, verifyOtpLoader, postVerifyOtpForRegistration,
    resendOtpTimer, sendOtpLoader, timer, verifiedOtpForRegistrationAction,
    instituteDetails, getUserProfileDetails
}) {
    useEffect(() => {
        updateOrgDetailsLoader(true)
        updateBlockRedirect(true)
        // document.addEventListener('contextmenu', contextMenuDisable);


        getOrgDetails(loadOrgCallback, history);
        return () => {
            updateBlockRedirect(false);
            // document.removeEventListener('contextmenu', contextMenuDisable);
        };
    }, []);

    const contextMenuDisable = event => event.preventDefault();

    const validateData = (value, label) => {
        const val = value ? String(value).trim() : "";
        if (label === "institute-pan") {
            if (val === "") {
                handleUpdateDetails(undefined, 'institutePanValid')
            } else if (val.length != 10) {
                handleUpdateDetails(false, 'institutePanValid')
            } else {
                handleUpdateDetails(true, 'institutePanValid')
            }
        } else if (label === "personal-pan") {
            if (val === "") {
                handleUpdateDetails(undefined, 'personalPanValid')
            } else if (val.length != 10) {
                handleUpdateDetails(false, 'personalPanValid')
            } else {
                handleUpdateDetails(true, 'personalPanValid')
            }
        } else if (label === "gst") {
            if (val === "") {
                handleUpdateDetails(undefined, 'gstValid')
            } else if (val.length != 15) {
                handleUpdateDetails(false, 'gstValid')
            } else {
                handleUpdateDetails(true, 'gstValid');
            }
        } else if (label === "cin") {
            if (val === "") {
                handleUpdateDetails(undefined, 'cinValid')
            } else if (val.length != 21) {
                handleUpdateDetails(false, 'cinValid')
            } else {
                handleUpdateDetails(true, 'cinValid')
            }
        } else if (label === "llpin") {
            if (val === "") {
                handleUpdateDetails(undefined, 'llpinValid')
            } else if (val.length != 7) {
                handleUpdateDetails(false, 'llpinValid')
            } else {
                handleUpdateDetails(true, 'llpinValid')
            }
        } else if (label === "pin") {
            if (val === "") {
                handleUpdateDetails(undefined, 'pincodeValid')
            } else if (val.length != 6) {
                handleUpdateDetails(false, 'pincodeValid')
            } else {
                handleUpdateDetails(true, 'pincodeValid');
            }
        } else if (label === 'adhaar') {
            if (val === "") {
                handleUpdateDetails(undefined, 'adhaarValid')
            } else if (val.length != 12) {
                handleUpdateDetails(false, 'adhaarValid')
            } else {
                handleUpdateDetails(true, 'adhaarValid')
            }
        }
    }

    const history = useHistory();

    const loadOrgCallback = async (data = null) => {
        updateOrgDetailsLoader(false);
        let ifscValid = data?.ifsc ? ifsc.validate(data?.ifsc) : false, branch = "", bankName = "";
        if (ifscValid) {
            try {
                await ifsc.fetchDetails(data?.ifsc).then(async function (res) {
                    bankName = res.BANK;
                    branch = res.BRANCH;
                });
            } catch (err) {
                console.error("ifsc fetchDetails error:", err);
            }
        }

        // window.onbeforeunload = function () {
        //     if (data?.kycStatus === "Pending" || data?.kycStatus === "Rejected") {
        //         return true
        //     }
        //     else return
        // }

        if (data?.kycStatus == 'Approved') {
            setIsEnabled(false)
        }

        let propDocType = data ? data.business_proof_type === "MSME/Udyam/Udyog Certificate" ? 'msme' :
            data.business_proof_type === "GST Certificate" ? 'gst' :
                data.business_proof_type === "Shop Establishment Act Certificate" ? 'shop_establishment' : null : null;

        let addrDocType = data ? data.proof_of_address_type !== "Voter ID" ? data.proof_of_address_type?.toLowerCase() : "voter" : null;
        if (data) {
            const docFields = [
                'pan_card', 'pan_card_status', 'pan_card_type', 'pan_card_comments',
                'institute_registration_proof', 'institute_registration_proof_status', 'institute_registration_proof_type', 'institute_registration_proof_comments',
                'form_12a', 'form_12a_status', 'form_12a_type', 'form_12a_comments',
                'form_80g', 'form_80g_status', 'form_80g_type', 'form_80g_comments',
                'cancelled_cheque', 'cancelled_cheque_status', 'cancelled_cheque_type', 'cancelled_cheque_comments',
                'aadhaar_front', 'aadhaar_front_status', 'aadhaar_front_type', 'aadhaar_front_comments',
                'aadhaar_back', 'aadhaar_back_status', 'aadhaar_back_type', 'aadhaar_back_comments',
                'voter_front', 'voter_front_status', 'voter_front_type', 'voter_front_comments',
                'voter_back', 'voter_back_status', 'voter_back_type', 'voter_back_comments',
                'passport_front', 'passport_front_status', 'passport_front_type', 'passport_front_comments',
                'passport_back', 'passport_back_status', 'passport_back_type', 'passport_back_comments',
                'msme', 'msme_status', 'msme_type', 'msme_comments',
                'gst', 'gst_status', 'gst_type', 'gst_comments',
                'shop_establishment', 'shop_establishment_status', 'shop_establishment_type', 'shop_establishment_comments',
                'gst_exemption_proof', 'gst_exemption_proof_status', 'gst_exemption_proof_type', 'gst_exemption_proof_comments'
            ];

            let originalDocs = null;
            try {
                const stored = sessionStorage.getItem('original_kyc_files');
                if (stored) {
                    const parsed = JSON.parse(stored);
                    if (parsed && parsed.id === data?.id) {
                        originalDocs = parsed.docs;
                    }
                }
            } catch (e) {
                console.error("Failed to read original kyc files from sessionStorage", e);
            }

            if (!originalDocs) {
                originalDocs = {};
                docFields.forEach(field => {
                    originalDocs[field] = data[field];
                });
                try {
                    sessionStorage.setItem('original_kyc_files', JSON.stringify({
                        id: data.id,
                        docs: originalDocs
                    }));
                } catch (e) {
                    console.error("Failed to write original kyc files to sessionStorage", e);
                }
            }

            const isSubmittedOrApproved = data?.kycStatus === "Submitted" || data?.kycStatus === "Approved" || data?.kycStatus === "Rejected";
            updateKycDeails({
                ...kycDetails,
                contactName: data?.contactName,
                contactPhone: data?.contactPhone,
                contactEmail: data?.contactEmail,
                noOfStudents: data?.strength,
                name: data?.name,
                website: data?.website,
                url: data?.url,
                businessPanNo: data?.institute_pan ? data?.institute_pan.toUpperCase() : '',
                orgType: data?.orgType,
                gstNo: data?.gstin ? data?.gstin.toUpperCase() : '',
                gstAvailable: data?.gstin && data?.gstin !== "" ? true : false,
                gstExempted: normalizeTriStateBool(data?.gst_exempted),
                gstExemptionType: data?.gst_exemption_type || undefined,
                gstEducationCategory: data?.gst_education_category || undefined,
                hsn_sac: data?.hsn_sac,
                pincode: data?.pincode,
                city: data?.city,
                state: data?.state,
                locality: data?.locality,
                coutry: data?.coutry,
                panOwnerName: (data?.pan_owner || '').trim(),
                cin: data?.cin ? data?.cin.toUpperCase() : '',
                personalPanNo: data?.pan ? data?.pan.toUpperCase() : '',
                beneficiaryName: data?.account_name,
                accNo: data?.account_no,
                ifsc: data?.ifsc ? data?.ifsc.toUpperCase() : '',
                accNoHidden: data?.account_no,
                llpin: data?.llpin ? data?.llpin.toUpperCase() : '',
                institutePanValid: data?.institute_pan?.length === 10,
                personalPanValid: data?.pan?.length === 10,
                gstValid: data?.gstin?.length === 15,
                cinValid: data?.cin?.length === 21,
                llpinValid: data?.llpin?.length === 7,
                pincodeValid: data?.pincode?.length === 6,
                adhaarValid: data?.aadhaar?.length === 12,
                ifscValid,
                bankName,
                branch,
                accNoMatch: true,
                proofOfAddrType: data?.proof_of_address_type,
                adhaarNo: data?.aadhaar ? data?.aadhaar.toUpperCase() : '',
                proprietorshipProof: data?.business_proof_type,
                kycStatus: data?.kycStatus || "Pending",
                pan_card: isSubmittedOrApproved ? originalDocs?.pan_card : null,
                [propDocType]: isSubmittedOrApproved ? (originalDocs ? originalDocs[propDocType] : null) : null,
                [addrDocType + '_front']: isSubmittedOrApproved ? (originalDocs ? originalDocs[addrDocType + '_front'] : null) : null,
                [addrDocType + '_back']: isSubmittedOrApproved ? (originalDocs ? originalDocs[addrDocType + '_back'] : null) : null,
                institute_registration_proof: isSubmittedOrApproved ? originalDocs?.institute_registration_proof : null,
                form_12a: isSubmittedOrApproved ? originalDocs?.form_12a : null,
                form_80g: isSubmittedOrApproved ? originalDocs?.form_80g : null,
                pan_card_status: isSubmittedOrApproved ? originalDocs?.pan_card_status : null,
                [propDocType + '_status']: isSubmittedOrApproved ? (originalDocs ? originalDocs[propDocType + '_status'] : null) : null,
                [addrDocType + '_front_status']: isSubmittedOrApproved ? (originalDocs ? originalDocs[addrDocType + '_front_status'] : null) : null,
                [addrDocType + '_back_status']: isSubmittedOrApproved ? (originalDocs ? originalDocs[addrDocType + '_back_status'] : null) : null,
                institute_registration_proof_status: isSubmittedOrApproved ? originalDocs?.institute_registration_proof_status : null,
                form_12a_status: isSubmittedOrApproved ? originalDocs?.form_12a_status : null,
                form_80g_status: isSubmittedOrApproved ? originalDocs?.form_80g_status : null,
                pan_card_type: isSubmittedOrApproved ? originalDocs?.pan_card_type : null,
                [propDocType + '_type']: isSubmittedOrApproved ? (originalDocs ? originalDocs[propDocType + '_type'] : null) : null,
                [addrDocType + '_front_type']: isSubmittedOrApproved ? (originalDocs ? originalDocs[addrDocType + '_front_type'] : null) : null,
                [addrDocType + '_back_type']: isSubmittedOrApproved ? (originalDocs ? originalDocs[addrDocType + '_back_type'] : null) : null,
                institute_registration_proof_type: isSubmittedOrApproved ? originalDocs?.institute_registration_proof_type : null,
                form_12a_type: isSubmittedOrApproved ? originalDocs?.form_12a_type : null,
                form_80g_type: isSubmittedOrApproved ? originalDocs?.form_80g_type : null,
                pan_card_comments: isSubmittedOrApproved ? originalDocs?.pan_card_comments : null,
                [propDocType + '_comments']: isSubmittedOrApproved ? (originalDocs ? originalDocs[propDocType + '_comments'] : null) : null,
                [addrDocType + '_front_comments']: isSubmittedOrApproved ? (originalDocs ? originalDocs[addrDocType + '_front_comments'] : null) : null,
                [addrDocType + '_back_comments']: isSubmittedOrApproved ? (originalDocs ? originalDocs[addrDocType + '_back_comments'] : null) : null,
                institute_registration_proof_comments: isSubmittedOrApproved ? originalDocs?.institute_registration_proof_comments : null,
                form_12a_comments: isSubmittedOrApproved ? originalDocs?.form_12a_comments : null,
                form_80g_comments: isSubmittedOrApproved ? originalDocs?.form_80g_comments : null,
                // The session copy of the documents can predate this proof's upload, and the reviewer's
                // approve/reject is made on the server after it, so the file falls back to the server's
                // and the status and comments are always the server's.
                gst_exemption_proof: isSubmittedOrApproved ? (originalDocs?.gst_exemption_proof || data?.gst_exemption_proof) : null,
                gst_exemption_proof_status: isSubmittedOrApproved ? data?.gst_exemption_proof_status : null,
                gst_exemption_proof_type: isSubmittedOrApproved ? (originalDocs?.gst_exemption_proof_type || data?.gst_exemption_proof_type) : null,
                gst_exemption_proof_comments: isSubmittedOrApproved ? data?.gst_exemption_proof_comments : null,
                // agreementAccepted: data?.kycStatus !== "Pending",
                agreementAccepted: data?.kycStatus === "Submitted" || data?.kycStatus === "Approved",
                cancelled_cheque: isSubmittedOrApproved ? originalDocs?.cancelled_cheque : null,
                addressProofIsAadhaar: data?.proof_of_address_type === "Aadhaar",
                aadhaar_front: isSubmittedOrApproved ? originalDocs?.aadhaar_front : null,
                aadhaar_back: isSubmittedOrApproved ? originalDocs?.aadhaar_back : null,
                superAdminName: data?.superAdminName,
                superAdminDesignation: data?.superAdminDesignation,
                phone: data?.phone,
                email: data?.email,
                // Schedule A of the agreement stamps this as the date and time the
                // terms were accepted. Without it moment(undefined) resolves to now,
                // so a submitted agreement reopened later claimed to have been signed
                // today rather than when it actually was.
                kycSubmittedOn: data?.kycSubmittedOn,

            })
        }
    }

    const [blockRedirect, updateBlockRedirect] = useState(false);

    const [fileName, updateFileName] = useState('');

    const [showImageModal, updateShowImgModal] = useState(false);

    const [orgDetailsLoader, updateOrgDetailsLoader] = useState(false);

    const [documentUploadLoader, updateDocUpdateLoader] = useState(false);

    const [submitLoader, toggleSubmitLoader] = useState(false)

    const [uploadDocType, updateUploadDocType] = useState('')

    const [formPage, changeFormPage] = useState("1");

    // Each tab pane keeps its own scroll container mounted (antd Tabs doesn't destroy
    // inactive panes by default), so it retains whatever scroll position it was left at.
    // Reset to top whenever Next/Previous switches the page.
    useEffect(() => {
        document.querySelectorAll('.kyc-tab-scroll').forEach(el => { el.scrollTop = 0; });
    }, [formPage]);

    const [showSubmitSuccessModal, toggleSubmitSuccesModal] = useState(false)

    const toggleSubmitSuccesModalWithClear = (val) => {
        if (val) {
            sessionStorage.removeItem('original_kyc_files');
        }
        toggleSubmitSuccesModal(val);
    }

    const [selectedDocType, updateDocType] = useState('');

    const [showEditCommentModal, updateShowEditCommentModal] = useState(false);

    const [kycDetails, updateKycDeails] = useState({
        contactName: '',
        contactPhone: '',
        contactEmail: '',
        emailValid: true,
        name: '',
        website: '',
        url: '',
        orgType: undefined,
        noOfStudents: undefined,
        businessPanNo: '',
        gstAvailable: undefined,
        gstNo: '',
        hsn_sac: '',
        locality: '',
        city: '',
        state: '',
        pincode: '',
        country: 'India',
        beneficiaryName: '',
        ifsc: '',
        ifscValid: undefined,
        accNoHidden: '',
        accNo: '',
        bankName: '',
        branch: '',
        accNoMatch: undefined,
        adhaarNo: '',
        addressFront: undefined,
        addressBack: undefined,
        panCard: undefined,
        businessReg: undefined,
        proofOfAddrType: undefined,
        cin: '',
        personalPanNo: '',
        panOwnerName: '',
        llpin: '',
        institutePanValid: undefined,
        personalPanValid: undefined,
        gstValid: undefined,
        cinValid: undefined,
        llpinValid: undefined,
        pincodeValid: undefined,
        adhaarValid: undefined,
        form12a: undefined,
        form80g: undefined,
        kycStatus: undefined,
        cancelled_cheque: undefined,
        addressProofIsAadhaar: false,
        gstExempted: undefined,
        gstExemptionType: undefined,
        gstEducationCategory: undefined,
        gst_exemption_proof: undefined

    })



    const [isSubmitModalVisible, setIsSubmitModalVisible] = useState(false)
    const handleDocClick = (docType) => {
        updateFileName(kycDetails[docType]);
        updateShowImgModal(true)
    }

    // useEffect(() => {
    //     if(formPage === "3"){
    //         console.log("Added");
    //         document.removeEventListener('contextmenu', contextMenuDisable);
    //         setTimeout(() => document.addEventListener('contextmenu', contextMenuDisable), 1000)

    //     }else{
    //         console.log("Removed");

    //         document.removeEventListener('contextmenu', contextMenuDisable);
    //     }

    // }, [formPage]);

    const beforeUpload = (file) => {
        const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png" || file.type === "application/pdf";
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isJpgOrPng) {
            Notification.error('error', "You can only upload JPG/PNG/PDF file!");
        } else if (!isLt5M) {
            Notification.error('error', "File size exceeds 5MB. Please upload a file smaller than 5MB");
        }
        return isJpgOrPng && isLt5M;
    }

    const handleUploadChange = (info, key) => {
        const { status } = info.file;
        if (status !== 'uploading') {
            //   console.log(info.file, info.fileList);
        }
        if (status === 'done' || status === 'error') {
            handleUploadDocument(info.file.originFileObj, key)
            // Notification.success('success', `${info.file.name} file uploaded successfully.`);
        } else if (status === 'error') {
            Notification.error('error', `${info.file.name} file upload failed.`);
        }
    }

    const handleUploadDocument = (file, key) => {
        updateDocUpdateLoader(true);
        updateUploadDocType(key);
        console.log({ file, key });
        uploadDocument(file, key, uploadCallback, (file, type) => updateKycDeails({
            ...kycDetails,
            [key]: file, [key + '_type']: type,
            [key + '_comment']: "", [key + '_status']: undefined
        }));

    }
    const uploadCallback = () => {
        updateDocUpdateLoader(false);
        updateUploadDocType('');
    }
    // const  handleFileDrop = (e) => {
    //     console.log('Dropped files', e.dataTransfer.files);
    // }

    // const handleUpdateDetails = (val, key) => {
    //     { console.log("kycDetails", kycDetails) }
    //     updateKycDeails({ ...kycDetails, [key]: val })
    // }
    const handleUpdateDetails = (val, key) => {
        { console.log("kycDetails", kycDetails) }
        // A field that's nothing but spaces should never be treated as filled in.
        if (typeof val === 'string' && val !== '' && val.trim() === '') {
            val = '';
        }
        const updates = { [key]: val };

        // Removing an uploaded document (docButton's "Remove Document"
        // button, which always clears via `null`) should also drop its
        // stale approved/rejected review status and reviewer comment -
        // otherwise the badge and comment icon from a previous submission
        // keep showing next to an empty upload slot, since they only ever
        // got cleared on a fresh re-upload, not on removal.
        if (val === null) {
            updates[key + '_status'] = undefined;
            updates[key + '_comments'] = undefined;
        }

        if (key === 'businessPanNo') {
            if (val === undefined || val === "") {
                updates.institutePanValid = undefined;
            } else {
                updates.institutePanValid = val.length === 10;
            }
        } else if (key === 'personalPanNo') {
            if (val === undefined || val === "") {
                updates.personalPanValid = undefined;
            } else {
                updates.personalPanValid = val.length === 10;
            }
        } else if (key === 'gstNo') {
            if (val === undefined || val === "") {
                updates.gstValid = undefined;
            } else {
                updates.gstValid = val.length === 15;
            }
        } else if (key === 'cin') {
            if (val === undefined || val === "") {
                updates.cinValid = undefined;
            } else {
                updates.cinValid = val.length === 21;
            }
        } else if (key === 'llpin') {
            if (val === undefined || val === "") {
                updates.llpinValid = undefined;
            } else {
                updates.llpinValid = val.length === 7;
            }
        } else if (key === 'adhaarNo') {
            if (val === undefined || val === "") {
                updates.adhaarValid = undefined;
            } else {
                updates.adhaarValid = val.length === 12;
            }
        } else if (key === 'pincode') {
            if (val === undefined || val === "") {
                updates.pincodeValid = undefined;
            } else if (val.length !== 6) {
                updates.pincodeValid = false;
            } else {
                updates.pincodeValid = true;
            }
        } else if (key === 'ifsc') {
            if (val === undefined || val === "") {
                updates.ifscValid = undefined;
                updates.bankName = '';
                updates.branch = '';
            } else {
                updates.ifscValid = ifsc.validate(val);
                if (!updates.ifscValid) {
                    updates.bankName = '';
                    updates.branch = '';
                } else {
                    ifsc.fetchDetails(val).then(res => {
                        if (res && res.BANK) {
                            updateKycDeails(prev => ({
                                ...prev,
                                bankName: res.BANK,
                                branch: res.BRANCH,
                                ifscValid: true
                            }));
                        }
                    }).catch(err => {
                        console.error("ifsc fetchDetails error on change:", err);
                    });
                }
            }
        } else if (key === 'accNoHidden') {
            if (val === undefined || val === "" || kycDetails.accNo === undefined || kycDetails.accNo === "") {
                updates.accNoMatch = undefined;
            } else {
                updates.accNoMatch = val === kycDetails.accNo;
            }
        } else if (key === 'accNo') {
            if (val === undefined || val === "" || kycDetails.accNoHidden === undefined || kycDetails.accNoHidden === "") {
                updates.accNoMatch = undefined;
            } else {
                updates.accNoMatch = kycDetails.accNoHidden === val;
            }
        }

        updateKycDeails(prev => ({ ...prev, ...updates }));
    }

    const handleSaveClick = () => {
        if (formPage === "1") {
            if (!validateEmail(kycDetails.contactEmail)) {
                return Notification.error('error', "Enter a valid email!")
            }
        }
        if (formPage === "2") {
            if (kycDetails.personalPanNo.length < 10) {
                return Notification.error('error', "Enter a valid PAN number (e.g., ABCDE1234F).")
            }
            if (kycDetails.orgType === "Private Limited") {
                if (kycDetails.businessPanNo.length < 10) {
                    return Notification.error('error', "Enter a valid PAN number (e.g., ABCDE1234F).")
                }
            } else if (kycDetails.pincode.length !== 6) {
                return Notification.error('error', "Enter a valid PIN Code!")
            }
        }
        // GST exemption. Saying "No" to the exemption means fees are taxed,
        // which cannot be done without a GSTIN - so the number is mandatory
        // before this tab is left.
        if (formPage === "3" && kycDetails.gstExempted === false) {
            if (!kycDetails.gstNo) {
                return Notification.error('error', "Enter your GSTIN to continue.")
            }
            if (kycDetails.gstValid !== true) {
                return Notification.error('error', "Enter a valid GSTIN (e.g., 22ABCDE1234F1Z5).")
            }
        }
        if (formPage === "6") {
            onSubmit()
        } else {
            changeFormPage((parseInt(formPage) + 1).toString())
        }
    }


    const onSubmit = () => {
        // toggleSubmitLoader(true)
        setIsSubmitModalVisible(true)


        if (kycDetails.orgType === "Private Limited" || kycDetails.orgType === "LLP" || kycDetails.orgType === "Trust" || kycDetails.orgType === "Society") {
            params = {
                contactName: kycDetails.contactName,
                contactPhone: kycDetails.contactPhone,
                contactEmail: kycDetails.contactEmail,
                name: kycDetails.name,
                website: kycDetails.website,
                url: kycDetails.url,
                orgType: kycDetails.orgType,//undefined,
                strength: kycDetails.noOfStudents,
                institute_pan: kycDetails.businessPanNo,
                gstin: kycDetails.gstNo,
                address: JSON.stringify({
                    locality: kycDetails.locality,
                    city: kycDetails.city,
                    state: kycDetails.state,
                    pincode: kycDetails.pincode
                }),
                hsn_sac: kycDetails.hsn_sac,
                country: kycDetails.country,
                account_name: kycDetails.beneficiaryName,
                ifsc: kycDetails.ifsc,
                account_no: kycDetails.accNo,
                proof_of_address_type: kycDetails.proofOfAddrType,
                cin: kycDetails.cin,
                llpin: kycDetails.llpin,
                pan: kycDetails.personalPanNo,
                pan_owner: kycDetails.panOwnerName,
                // The proof file itself is persisted by /fee/files at upload time
                // (keyed by `gst_exemption_proof`), same as every other KYC
                // document - only the flag and the discriminator travel here.
                gst_exempted: kycDetails.gstExempted,
                // Empty string rather than null: postKycDetails strips null keys
                // from the payload, which would leave a stale type in the DB when
                // someone switches their answer back to "not exempted".
                gst_exemption_type: kycDetails.gstExempted ? kycDetails.gstExemptionType : "",
                gst_education_category: kycDetails.gstExempted && kycDetails.gstExemptionType === GST_EXEMPTION_EDUCATIONAL
                    ? kycDetails.gstEducationCategory : "",
            }

            // postKycDetails(params, () => toggleSubmitLoader(false), () => toggleSubmitSuccesModal(true))
        } else if (kycDetails.orgType === "Proprietorship" || kycDetails.orgType === "Partnership" ||
            kycDetails.orgType === "Not Registered") {
            params = {
                contactName: kycDetails.contactName,
                contactPhone: kycDetails.contactPhone,
                contactEmail: kycDetails.contactEmail,
                name: kycDetails.name,
                website: kycDetails.website,
                url: kycDetails.url,
                orgType: kycDetails.orgType,
                strength: kycDetails.noOfStudents,
                gstin: kycDetails.gstNo,
                address: JSON.stringify({
                    locality: kycDetails.locality,
                    city: kycDetails.city,
                    state: kycDetails.state,
                    pincode: kycDetails.pincode
                }),
                hsn_sac: kycDetails.hsn_sac,
                country: kycDetails.country,
                account_name: kycDetails.beneficiaryName,
                ifsc: kycDetails.ifsc,
                account_no: kycDetails.accNo,
                proof_of_address_type: kycDetails.proofOfAddrType,
                cin: kycDetails.cin,
                pan: kycDetails.personalPanNo,
                pan_owner: kycDetails.panOwnerName,
                // The proof file itself is persisted by /fee/files at upload time
                // (keyed by `gst_exemption_proof`), same as every other KYC
                // document - only the flag and the discriminator travel here.
                gst_exempted: kycDetails.gstExempted,
                // Empty string rather than null: postKycDetails strips null keys
                // from the payload, which would leave a stale type in the DB when
                // someone switches their answer back to "not exempted".
                gst_exemption_type: kycDetails.gstExempted ? kycDetails.gstExemptionType : "",
                gst_education_category: kycDetails.gstExempted && kycDetails.gstExemptionType === GST_EXEMPTION_EDUCATIONAL
                    ? kycDetails.gstEducationCategory : "",
                aadhaar: kycDetails.adhaarNo,
                business_proof_type: kycDetails.proprietorshipProof,
            }

            // postKycDetails(params, () => toggleSubmitLoader(false), () => toggleSubmitSuccesModal(true))
        }

    }

    const handleEditCommentClick = (docType) => {
        updateDocType(docType);
        updateShowEditCommentModal(true)
    }

    const changeAddressProofType = (type) => {
        if (type !== kycDetails.proofOfAddrType)
            updateKycDeails({ ...kycDetails, proofOfAddrType: type, addressFront: false, addressBack: false })
    }

    const changeProprietoshipProofType = (type) => {
        if (type !== kycDetails.proprietorshipProof)
            updateKycDeails({ ...kycDetails, proprietorshipProof: type, businessReg: false })
    }

    const handleIfscUpdate = async (e) => {
        const val = kycDetails.ifsc ? String(kycDetails.ifsc).trim().toUpperCase() : "";
        if (ifsc.validate(val)) {
            try {
                const res = await ifsc.fetchDetails(val);
                if (res && res.BANK) {
                    updateKycDeails(prev => ({
                        ...prev,
                        bankName: res.BANK,
                        branch: res.BRANCH,
                        ifscValid: true
                    }));
                } else {
                    updateKycDeails(prev => ({
                        ...prev,
                        bankName: '',
                        branch: '',
                        ifscValid: true
                    }));
                }
            } catch (err) {
                updateKycDeails(prev => ({
                    ...prev,
                    bankName: '',
                    branch: '',
                    ifscValid: true
                }));
            }
        } else {
            updateKycDeails(prev => ({
                ...prev,
                bankName: '',
                branch: '',
                ifscValid: false
            }));
        }
    }

    const handlePinUpdate = e => {
        fetchPinCodeDetails(e.target.value, pinUpdateCallback)
    }

    const pinUpdateCallback = (response) => {
        const data = response?.[0];
        if (data?.Status === "Success") {
            const details = data.PostOffice[0]
            updateKycDeails(prev => ({ ...prev, city: details.District, state: details.State, pincodeValid: true }))
        } else {
            updateKycDeails(prev => ({ ...prev, city: '', state: '', pincodeValid: false }))
        }
    }


    let disableSave = true;
    if (kycDetails.orgType === "Private Limited") {
        disableSave = (kycDetails.name === "" ||
            !kycDetails.institutePanValid || !kycDetails.cinValid ||
            !kycDetails.personalPanValid || !kycDetails.panOwnerName?.trim() ||
            kycDetails.locality === "" || kycDetails.city === "" ||
            kycDetails.state === "" || !kycDetails.pincodeValid
            || kycDetails.country === "" || (kycDetails.gstAvailable && (!kycDetails.gstValid)))
    } else if (kycDetails.orgType === "Proprietorship" || kycDetails.orgType === "Partnership") {
        disableSave = (kycDetails.name === "" ||
            !kycDetails.personalPanValid || !kycDetails.panOwnerName?.trim() ||
            kycDetails.locality === "" || kycDetails.city === "" ||
            kycDetails.state === "" || !kycDetails.pincodeValid
            || kycDetails.country === "" || (kycDetails.gstAvailable && (!kycDetails.gstValid)))
    } else if (kycDetails.orgType === "LLP") {
        disableSave = (kycDetails.name === "" ||
            !kycDetails.institutePanValid || !kycDetails.llpinValid ||
            !kycDetails.personalPanValid || !kycDetails.panOwnerName?.trim() ||
            kycDetails.locality === "" || kycDetails.city === "" ||
            kycDetails.state === "" || !kycDetails.pincodeValid
            || kycDetails.country === "" || (kycDetails.gstAvailable && (!kycDetails.gstValid)))
    } else if (kycDetails.orgType === "Trust" || kycDetails.orgType === "Society") {
        disableSave = (kycDetails.name === "" ||
            !kycDetails.institutePanValid ||
            !kycDetails.personalPanValid || !kycDetails.panOwnerName?.trim() ||
            kycDetails.locality === "" || kycDetails.city === "" ||
            kycDetails.state === "" || !kycDetails.pincodeValid
            || kycDetails.country === "" || (kycDetails.gstAvailable && (!kycDetails.gstValid)))
    } else if (kycDetails.orgType === "Not Registered") {
        disableSave = (kycDetails.name === "" ||
            !kycDetails.personalPanValid || !kycDetails.panOwnerName?.trim() ||
            kycDetails.locality === "" || kycDetails.city === "" ||
            kycDetails.state === "" || !kycDetails.pincodeValid
            || kycDetails.country === "")
    }

    let disableSave2 = true;
    let propDocType = kycDetails.proprietorshipProof === "MSME/Udyam/Udyog Certificate" ? 'msme' :
        kycDetails.proprietorshipProof === "GST Certificate" ? 'gst' :
            kycDetails.proprietorshipProof === "Shop Establishment Act Certificate" ? 'shop_establishment' : null;

    let addrDocType = kycDetails.proofOfAddrType !== "Voter ID" ? kycDetails.proofOfAddrType?.toLowerCase() : "voter";

    if (kycDetails.orgType === "Private Limited" || kycDetails.orgType === "LLP") {
        disableSave2 = (kycDetails.proofOfAddrType && (!kycDetails[addrDocType + '_front'] || !kycDetails[addrDocType + '_back']) || !kycDetails.pan_card || !kycDetails.institute_registration_proof ||
            (kycDetails.proofOfAddrType && (kycDetails[addrDocType + '_front_status'] === "rejected" || kycDetails[addrDocType + '_back_status'] === "rejected")) || kycDetails.pan_card_status === "rejected"
            || kycDetails.institute_registration_proof_status === "rejected"
            || (kycDetails.gstAvailable && (!kycDetails.gst || kycDetails.gst_status === "rejected"))
        )
    } else if (kycDetails.orgType === "Proprietorship") {
        disableSave2 = (!kycDetails.adhaarValid || !kycDetails[addrDocType + '_front'] ||
            !kycDetails[addrDocType + '_back'] || !kycDetails.pan_card || (propDocType && !kycDetails[propDocType])
            || !kycDetails.aadhaar_front || kycDetails.aadhaar_front_status === "rejected" || !kycDetails.aadhaar_back || kycDetails.aadhaar_front_back === "rejected" ||
            (propDocType === "gst" && !kycDetails.gstValid) ||
            (kycDetails[addrDocType + '_front_status'] === "rejected" ||
                kycDetails[addrDocType + '_back_status'] === "rejected")) || kycDetails.pan_card_status === "rejected"
            || (propDocType && kycDetails[propDocType + '_status'] === "rejected")
            || (kycDetails.gstAvailable && propDocType !== "gst" && (!kycDetails.gst || kycDetails.gst_status === "rejected"))
    } else if (kycDetails.orgType === "Partnership") {
        disableSave2 = (!kycDetails.adhaarValid || !kycDetails[addrDocType + '_front'] ||
            !kycDetails.aadhaar_front || kycDetails.aadhaar_front_status === "rejected" || !kycDetails.aadhaar_back || kycDetails.aadhaar_front_back === "rejected" ||
            !kycDetails[addrDocType + '_back'] || !kycDetails.pan_card || !kycDetails.institute_registration_proof ||
            kycDetails[addrDocType + '_front_status'] === "rejected" || kycDetails[addrDocType + '_back_status'] === "rejected" || kycDetails.pan_card_status === "rejected" || kycDetails.institute_registration_proof_status === "rejected"
            || (kycDetails.gstAvailable && (!kycDetails.gst || kycDetails.gst_status === "rejected")))
    } else if (kycDetails.orgType === "Trust" || kycDetails.orgType === "Society") {
        disableSave2 = (kycDetails.proofOfAddrType && (!kycDetails[addrDocType + '_front'] ||
            !kycDetails[addrDocType + '_back']) || !kycDetails.pan_card || !kycDetails.institute_registration_proof ||
            !kycDetails.form_12a || !kycDetails.form_80g ||
            (kycDetails.proofOfAddrType && (kycDetails[addrDocType + '_front_status'] === "rejected" || kycDetails[addrDocType + '_back_status'] === "rejected")) ||
            kycDetails.pan_card_status === "rejected" || kycDetails.institute_registration_proof_status === "rejected" ||
            kycDetails.form_12a_status === "rejected" || kycDetails.form_80g_status === "rejected")
    } else if (kycDetails.orgType === "Not Registered") {
        disableSave2 = (!kycDetails.adhaarValid || !kycDetails[addrDocType + '_front'] ||
            !kycDetails[addrDocType + '_back'] || !kycDetails.aadhaar_front || kycDetails.aadhaar_front_status === "rejected" || !kycDetails.aadhaar_back || kycDetails.aadhaar_front_back === "rejected" ||
            (kycDetails[addrDocType + '_front_status'] === "rejected" || kycDetails[addrDocType + '_back_status'] === "rejected")
            || !kycDetails.pan_card || kycDetails.pan_card_status === "rejected")
    }

    // GST exemption tab: the question must be answered, and answering "yes"
    // additionally requires a reason plus an accepted proof document.
    let disableSave3 = kycDetails.gstExempted === undefined;
    // Not exempted means GST is charged on fees, which needs a GSTIN
    if (kycDetails.gstExempted === false) {
        disableSave3 = !kycDetails.gstValid;
    }
    if (kycDetails.gstExempted === true) {
        disableSave3 = (!kycDetails.gstExemptionType ||
            (kycDetails.gstExemptionType === GST_EXEMPTION_EDUCATIONAL && !kycDetails.gstEducationCategory) ||
            !kycDetails.gst_exemption_proof ||
            kycDetails.gst_exemption_proof_status === "rejected")
    }

    const compareAcNo = () => {
        if (!kycDetails.accNo) {
            handleUpdateDetails(undefined, 'accNoMatch');
            return;
        }
        if (kycDetails.accNoHidden === kycDetails.accNo) {
            handleUpdateDetails(true, 'accNoMatch')
        } else {
            handleUpdateDetails(false, 'accNoMatch')
        }
    }

    const changeGstAvailability = (e) => {
        if (e.target.value) {
            handleUpdateDetails(true, 'gstAvailable')
        } else {
            // gstValid has to go with the number it described - leaving a stale
            // `true` behind would let the GST exemption tab's "No" branch pass
            // its mandatory-GSTIN check on an empty field.
            updateKycDeails({ ...kycDetails, gstAvailable: false, gstNo: '', gstValid: undefined })
        }
    }

    // Switching the answer away from "exempted" - or to a different reason -
    // invalidates whatever proof was uploaded for the previous answer, so drop
    // the file along with its review status and reviewer comment.
    const clearGstExemptionProof = {
        gst_exemption_proof: null,
        gst_exemption_proof_status: undefined,
        gst_exemption_proof_type: undefined,
        gst_exemption_proof_comments: undefined
    }

    const changeGstExempted = (e) => {
        if (e.target.value === kycDetails.gstExempted) return;
        if (e.target.value) {
            updateKycDeails({ ...kycDetails, gstExempted: true })
        } else {
            updateKycDeails({
                ...kycDetails, gstExempted: false, gstExemptionType: undefined,
                gstEducationCategory: undefined, ...clearGstExemptionProof
            })
        }
    }

    const changeGstExemptionType = (type) => {
        if (type === kycDetails.gstExemptionType) return;
        updateKycDeails({
            ...kycDetails, gstExemptionType: type,
            // The category question only exists under the educational route, so
            // leaving that route must not strand an answer to a question that is
            // no longer on screen.
            gstEducationCategory: type === GST_EXEMPTION_EDUCATIONAL ? kycDetails.gstEducationCategory : undefined,
            ...clearGstExemptionProof
        })
    }

    const changeGstEducationCategory = (category) => {
        if (category === kycDetails.gstEducationCategory) return;
        updateKycDeails({ ...kycDetails, gstEducationCategory: category, ...clearGstExemptionProof })
    }

    const updateAddressProofTypeIsAadhaar = (e) => {
        if (e.target.value) {
            updateKycDeails({ ...kycDetails, addressProofIsAadhaar: true, proofOfAddrType: 'Aadhaar' })
        } else {
            updateKycDeails({ ...kycDetails, addressProofIsAadhaar: false, proofOfAddrType: '' })
        }
    }

    const [isEnabled, setIsEnabled] = useState(true)
    const [activeTab, setActiveTab] = useState(1)

    const tabChangeHandler = (key) => {
        if (organisationDetails?.kycStatus == 'Approved') {
            setIsEnabled(false)
            setActiveTab(key)
        }
    }

    return (
        <>
            {/* <Prompt
                when={false}
                message="Are you sure you want to leave?"
                /> */}

            <div style={{ height: "100%" }}>
                <div className='r-c-sb'>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <ArrowLeftOutlined
                            style={{ fontSize: 20, marginRight: 15, cursor: 'pointer', color: '#000' }}
                            onClick={() => history.goBack()}
                        />
                        <div className='text-mdl bold-700'>KYC Form </div>
                    </div>
                </div>
                <Tabs className="kycTab" activeKey={isEnabled ? `${formPage}` : `${activeTab}`} onChange={(key) => { tabChangeHandler(key) }} defaultActiveKey="1">
                    <TabPane tab={<span className="bold-700">CONTACT INFORMATION</span>} disabled={isEnabled} key={1}>
                        <div className="r-c-jsb" style={{ height: "80vh" }}>
                            <div className="kyc-tab-scroll" style={{ width: '100%', height: '95%', overflowY: 'auto', paddingRight: '40px' }}>
                                {contactInfo(kycDetails, handleUpdateDetails, verifiedOtpforRegistration, setVerfiyOtpModal, postMobileNumberForRegistration, verfiyOtpModal, otpKey, verifyOtpLoader, postVerifyOtpForRegistration, resendOtpTimer, sendOtpLoader, timer, verifiedOtpForRegistrationAction, organisationDetails)}
                            </div>
                            {isEnabled ? actionButtons(formPage, changeFormPage, kycDetails, handleSaveClick, disableSave, disableSave2, disableSave3, submitLoader, verifiedOtpforRegistration) : null}
                        </div>
                    </TabPane>
                    <TabPane tab={<span className="bold-700">BUSINESS DETAILS</span>} disabled={isEnabled} key={2}>
                        <div className="r-c-jsb" style={{ height: "80vh" }}>
                            <div className="kyc-tab-scroll" style={{ width: '100%', height: '95%', overflowY: 'auto', paddingRight: '40px' }}>
                                {businessInfo(kycDetails, handleUpdateDetails, validateData, handlePinUpdate, changeGstAvailability, instituteDetails)}
                            </div>
                            {isEnabled ? actionButtons(formPage, changeFormPage, kycDetails, handleSaveClick, disableSave, disableSave2, disableSave3) : null}
                        </div>
                    </TabPane>
                    <TabPane tab={<span className="bold-700">GST EXEMPTION</span>} disabled={isEnabled} key={3}>
                        <div className="r-c-jsb" style={{ height: "80vh" }}>
                            <div className="kyc-tab-scroll" style={{ width: '100%', height: '95%', overflowY: 'auto', paddingRight: '20px' }}>
                                {gstExemption(kycDetails, handleUpdateDetails, changeGstExempted, changeGstExemptionType,
                                    changeGstEducationCategory, handleUploadChange, beforeUpload, handleDocClick, handleEditCommentClick)}
                            </div>
                            {isEnabled ? actionButtons(formPage, changeFormPage, kycDetails, handleSaveClick, disableSave, disableSave2, disableSave3) : null}
                        </div>
                    </TabPane>
                    <TabPane tab={<span className="bold-700">BANK ACCOUNT</span>} disabled={isEnabled} key={4}>
                        <div className="r-c-jsb" style={{ height: "80vh" }}>
                            <div className="kyc-tab-scroll" style={{ width: '100%', height: '95%', overflowY: 'auto', paddingRight: '40px' }}>
                                {bankDetails(kycDetails, handleUpdateDetails, handleIfscUpdate, compareAcNo, handleUploadChange, beforeUpload, handleDocClick, handleEditCommentClick)}
                            </div>
                            {isEnabled ? actionButtons(formPage, changeFormPage, kycDetails, handleSaveClick, disableSave, disableSave2, disableSave3) : null}
                        </div>
                    </TabPane>
                    <TabPane tab={<span className="bold-700">DOCUMENTS VERIFICATION</span>} disabled={isEnabled} key={5}>
                        <div className="r-c-jsb" style={{ height: "80vh" }}>
                            <div className="kyc-tab-scroll" style={{ width: '100%', height: '95%', overflowY: 'auto', paddingRight: '40px' }}>
                                <div className="text-xs m-t-10 dark-grey">Upload JPG, PNG, or PDF files (max 5 MB each).</div>
                                {kycDetails.orgType === "Private Limited" || kycDetails.orgType === "LLP" ||
                                    kycDetails.orgType === "Trust" || kycDetails.orgType === "Society"
                                    ?
                                    documentDetailsPvt(handleDocClick, kycDetails, handleEditCommentClick, handleUpdateDetails, beforeUpload, handleUploadChange, changeAddressProofType, updateAddressProofTypeIsAadhaar)
                                    : kycDetails.orgType === "Proprietorship" ?
                                        documentDetailsProp(handleDocClick, kycDetails, handleEditCommentClick, handleUpdateDetails, beforeUpload, handleUploadChange, validateData,
                                            changeAddressProofType, changeProprietoshipProofType, updateAddressProofTypeIsAadhaar)
                                        : kycDetails.orgType === "Partnership" ?
                                            documentDetailsPartner(handleDocClick, kycDetails, handleEditCommentClick, handleUpdateDetails, beforeUpload, handleUploadChange, validateData, changeAddressProofType, updateAddressProofTypeIsAadhaar)
                                            :
                                            documentDetailsNtRegistered(handleDocClick, kycDetails, handleEditCommentClick, handleUpdateDetails, beforeUpload, handleUploadChange, validateData, changeAddressProofType, updateAddressProofTypeIsAadhaar)
                                }
                            </div>
                            {isEnabled ? actionButtons(formPage, changeFormPage, kycDetails, handleSaveClick, disableSave, disableSave2, disableSave3, submitLoader) : null}
                        </div>
                    </TabPane>
                    <TabPane tab={<span className="bold-700">AGREEMENT</span>} disabled={isEnabled} key={6}>
                        <div className="r-c-jsb" style={{ height: "80vh" }}>
                            <div className="kyc-tab-scroll" style={{ width: '100%', height: '95%', overflowY: 'auto', paddingRight: '40px' }}>
                                {agreement(kycDetails, handleUpdateDetails)}
                            </div>
                            {isEnabled ? actionButtons(formPage, changeFormPage, kycDetails, handleSaveClick, disableSave, disableSave2, disableSave3, submitLoader) : null}
                        </div>
                    </TabPane>

                </Tabs >

                {
                    isSubmitModalVisible ?
                        <ConfirmSubmitModal isSubmitModalVisible={isSubmitModalVisible} setIsSubmitModalVisible={setIsSubmitModalVisible} postKycDetails={postKycDetails} params={params} toggleSubmitSuccesModal={toggleSubmitSuccesModalWithClear} history={history} />
                        :
                        <></>
                }
                <PageDataLoader visible={orgDetailsLoader || documentUploadLoader} />
                {/* {
                    showSubmitSuccessModal ?
                        <SubmitSuccess visible={showSubmitSuccessModal} onClose={() => toggleSubmitSuccesModalWithClear(false)} history={history} />
                        :
                        <></>
                }  -- removing submitSuccess modal as sending from backend*/}
                {showImageModal && <ImgViewModal visible={showImageModal} closeModal={() => updateShowImgModal(false)} fileName={fileName} />}
                {showEditCommentModal && <EditCommentModal visible={showEditCommentModal} closeModal={() => updateShowEditCommentModal(false)} documentType={selectedDocType} comment={kycDetails[selectedDocType + '_comments']} />}


            </div >
        </>

    )
}

const mapStateToProps = state => {
    const {
        organisationDetails
    } = state.kyc;
    const { instituteDetails } = state.profileNew;
    const { verifiedOtpforRegistration, verfiyOtpModal, otpKey, verifyOtpLoader, resendOtpTimer, sendOtpLoader, timer } = state.login
    return {
        organisationDetails,
        instituteDetails,
        verifiedOtpforRegistration, verfiyOtpModal, otpKey, verifyOtpLoader, resendOtpTimer, sendOtpLoader, timer
    };
};

const mapDispatchToProps = dispatch => ({
    getOrgDetails: (callback, history) => dispatch(getOrgDetails(callback, history)),
    uploadDocument: (file, key, callback, successCallback) => dispatch(uploadDocument(file, key, callback, successCallback)),
    postKycDetails: (params, callback, successCallBack) => dispatch(postKycDetails(params, callback, successCallBack)),
    fetchPinCodeDetails: (pin, callback) => dispatch(fetchPinCodeDetails(pin, callback)),
    setVerfiyOtpModal: (bool) => dispatch(setVerfiyOtpModal(bool)),
    postMobileNumberForRegistration: (phone, history) => dispatch(postMobileNumberForRegistration(phone, history)),
    postVerifyOtpForRegistration: (otp, key) => dispatch(postVerifyOtpForRegistration(otp, key)),
    verifiedOtpForRegistrationAction: (bool) => dispatch(verifiedOtpForRegistrationAction(bool)),
    // getUserProfileDetails: (callback) => dispatch(getUserProfileDetails(callback))
});


export default connect(mapStateToProps, mapDispatchToProps)(KycForm);